import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BlobService } from './api/blob.service';
import { BlogService } from './api/blog.service';
import { BlogCategoryService } from './api/blogCategory.service';
import { ContactPageService } from './api/contactPage.service';
import { DeliveryPageService } from './api/deliveryPage.service';
import { EventService } from './api/event.service';
import { EventsPageService } from './api/eventsPage.service';
import { FAQService } from './api/fAQ.service';
import { FieldService } from './api/field.service';
import { FlatPageService } from './api/flatPage.service';
import { HistoryCategoryService } from './api/historyCategory.service';
import { HistoryInfoService } from './api/historyInfo.service';
import { HomepageService } from './api/homepage.service';
import { HotelsAndAttractionsService } from './api/hotelsAndAttractions.service';
import { ImportExportService } from './api/importExport.service';
import { LAXPageService } from './api/lAXPage.service';
import { MerchantService } from './api/merchant.service';
import { MerchantCategoryService } from './api/merchantCategory.service';
import { MerchantSubCategoryService } from './api/merchantSubCategory.service';
import { OrderService } from './api/order.service';
import { PrivacyPolicySectionsService } from './api/privacyPolicySections.service';
import { ProductService } from './api/product.service';
import { ProductCategoryService } from './api/productCategory.service';
import { SKUService } from './api/sKU.service';
import { UploadService } from './api/upload.service';
import { VisitorCategorySectionService } from './api/visitorCategorySection.service';
import { VisitorMapAndHoursService } from './api/visitorMapAndHours.service';
import { VisitorPageService } from './api/visitorPage.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    BlobService,
    BlogService,
    BlogCategoryService,
    ContactPageService,
    DeliveryPageService,
    EventService,
    EventsPageService,
    FAQService,
    FieldService,
    FlatPageService,
    HistoryCategoryService,
    HistoryInfoService,
    HomepageService,
    HotelsAndAttractionsService,
    ImportExportService,
    LAXPageService,
    MerchantService,
    MerchantCategoryService,
    MerchantSubCategoryService,
    OrderService,
    PrivacyPolicySectionsService,
    ProductService,
    ProductCategoryService,
    SKUService,
    UploadService,
    VisitorCategorySectionService,
    VisitorMapAndHoursService,
    VisitorPageService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
